export default DirectionController;

/** @ngInject */
function DirectionController(Mapa, $timeout) {
  var vm = this;
  var api, mapa;

  // timeout necessario, pois o mapa deve ser carregado após o vm.elem ser renderizado
  $timeout(carregarApi, 0);

  function carregarApi() {
    Mapa.obterApi().then(carregarMapa);
  }

  function carregarMapa(maps) {
    api = maps;

    mapa = new api.Map(vm.elem, {
      streetViewControl: false,
      zoomControl: true,
      mapMaker: false,
      panControl: false,
      mapTypeId: api.MapTypeId.ROADMAP
    });

    buscarRota();
  }

  function buscarRota() {
    var request = {
      origin: latLng(vm.origem),
      destination: latLng(vm.destino),
      waypoints: (vm.waypoints || []).map(latLng).map(location),
      provideRouteAlternatives: true,
      travelMode: api.TravelMode.DRIVING
    };

    new api.DirectionsService().route(request, adicionarRotaMapa);
  }

  function adicionarRotaMapa(response, status) {
    if (status === api.DirectionsStatus.OK) {
      return new api.DirectionsRenderer({map: mapa, directions: response});
    }
  }

  function latLng(coords) {
    return new api.LatLng(coords[0], coords[1]);
  }

  function location(objLatLng) {
    return {location: objLatLng};
  }
}



/** WEBPACK FOOTER **
 ** ./common/components/mapa/direction.controller.ts
 **/